<template>
  <table class="default-table">
    <thead>
      <tr class="table100-head">
        <th
          v-for="headerItem in tableHeaders"
          :key="headerItem.value"
          @click="changeArrowDir(headerItem.value)"
        >
          {{ headerItem.displayText }}
          <span v-if="filters.orderCol == headerItem.value">
            <img :src="require(`@/assets/icons/${arrowDirection}-arrow.svg`)" />
          </span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="alert in alerts"
        :key="alert.id"
        :class="{ selected: openedAlert == alert.id }"
      >
        <td>
          {{ formatDateWithHour(alert.date) }}
        </td>
        <td class="text-center">
          {{ alert.type }}
        </td>
        <td class="text-center">
          {{ alert.nkrCode }}
        </td>
        <td>
          {{ alert.title }}
        </td>
        <td>
          <div class="flex flex-row gap-2 justify-center items-center">
            <button
              v-if="alert.hidden == 0"
              class="btn-error-button"
              @click="hideAlert(alert.id)"
            >
              hideAlert
            </button>
            <button
              v-else
              class="btn-info-button"
              @click="unhideAlert(alert.id)"
            >
              unhide
            </button>
            <button
              @click="open(alert.id)"
              class="w-10 bg-gray-200 rounded-full p-2"
            >
              <img src="@/assets/icons/eye.svg" alt="view" />
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import { formatDateWithHour } from "@/helpers/globalHelpers.js";

export default {
  props: {
    alerts: {
      type: Array,
      required: true
    },
    openedAlert: {
      type: String,
      required: true
    },
    filters: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      tableHeaders: [
        {
          displayText: "Date",
          value: "date"
        },
        {
          displayText: "Type",
          value: "type"
        },
        {
          displayText: "nkr code",
          value: "nkrCode"
        },
        {
          displayText: "title",
          value: "title"
        },
        {
          displayText: "Actions",
          value: "actions"
        }
      ]
    };
  },
  methods: {
    formatDateWithHour,
    open(id) {
      this.$emit("open", id);
    },
    hideAlert(id) {
      this.$emit("hideAlert", id);
    },
    unhideAlert(id) {
      this.$emit("unhideAlert", id);
    }
  }
};
</script>
